import * as React from "react";
const SvgFiRrBusAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-bus-alt_svg__a)">
      <path
        fill="#062147"
        d="M22 10V6.42q0-.352-.04-.7A5.93 5.93 0 0 0 17.4.584a25.4 25.4 0 0 0-10.8 0A5.93 5.93 0 0 0 2.04 5.72q-.04.348-.04.7V10a2 2 0 0 0-2 2v1a2 2 0 0 0 2 2v2a5 5 0 0 0 2 4v.5a2.5 2.5 0 0 0 4.95.5h6.1a2.5 2.5 0 0 0 4.95-.5V21a5 5 0 0 0 2-4v-2a2 2 0 0 0 2-2v-1a2 2 0 0 0-2-2M4 13V7h16v6zM7.052 2.532c3.262-.71 6.638-.71 9.9 0A3.93 3.93 0 0 1 19.746 5H16a1 1 0 0 0-1-1H9a1 1 0 0 0-1 1H4.254a3.93 3.93 0 0 1 2.798-2.468M17 20H7a3 3 0 0 1-3-3v-2h2v1a1 1 0 1 0 2 0v-1h8v1a1 1 0 0 0 2 0v-1h2v2a3 3 0 0 1-3 3"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-bus-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBusAlt;
